var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { Typography } from '@lucidlink/uicore';
import { ModalTestIdFactory } from '@lucidlink/uicore/interactions';
export const ModalDescription = ({ children, className, id, }) => (_jsx(Typography, { align: "center", className: className, "data-testid": ModalTestIdFactory.getModalDescriptionBase(), id: id, kind: "p", children: children }));
_react_refresh_temp_1 = ModalDescription;
$RefreshReg$(_react_refresh_temp_1, "ModalDescription");
